import type { CreditAmount } from "@/features/referral/models";
import { creditSchema } from "@/features/referral/models";
import { parseResponseData, privateAPI } from "@/shared/lib";

const BASE_ENDPOINT = "patients/referrals/credit";

export const getCredit = async () => {
  const response = await privateAPI.get(BASE_ENDPOINT);

  return parseResponseData(response, creditSchema);
};

export const applyCreditAmount = async (amount: CreditAmount) => {
  return await privateAPI.post(`${BASE_ENDPOINT}/apply`, { amount });
};
